import { useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { useApi } from "../../../../hooks/useApi"

import { ShortLocateResponse } from "../types/common"

const useCreateManualShortLocate = ({
  onSuccess,
  onError,
}: {
  onSuccess: (response: ShortLocateResponse) => void
  onError: (error: AxiosError) => void
}) => {
  const { scientApi } = useApi()
  return useMutation(scientApi.trading.createManualShortLocate, { onSuccess, onError })
}

export default useCreateManualShortLocate
